import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { OverviewPage } from './OverviewPage';
import { PartialConfigForm } from './PartialConfigForm';
import { NotFoundPage } from '../NotFoundPage';
import { isPartialConfigCategory, isSwarmType } from './utils';

function PartialConfigFormWrapper() {
    const { swarmType, type, id } = useParams();

    if (!isSwarmType(swarmType)) {
        return null;
    }

    if (!isPartialConfigCategory(type)) {
        return null;
    }

    return <PartialConfigForm swarmType={swarmType} partialConfigType={type} id={id} />;
}

export function PartialConfigRoutes() {
    return (
        <Routes>
            <Route index element={<OverviewPage />} />
            <Route element={<OverviewPage />}>
                <Route path="create/:swarmType/:type" element={<PartialConfigFormWrapper />} />
                <Route path="edit/:swarmType/:type/:id" element={<PartialConfigFormWrapper />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}
